import tables from "modules/CorporateCardRequests/constants/tables";

export const tabsData = [
  {
    id: 1,
    key: "user",
    label: "My requests",
    accordions: [
      {
        id: 1,
        apiKey: "awaiting_your_action",
        title: "Requires your action",
        table: tables.user,
      },
      {
        id: 2,
        apiKey: "awaiting_others_action",
        title: "Awaiting other's action",
        table: tables.user,
      },
      {
        id: 3,
        apiKey: "historical",
        title: "Archives",
        table: tables.user,
      },
    ],
  },
  {
    id: 2,
    key: "supervisor",
    label: "Supervisor",
    accordions: [
      {
        id: 1,
        apiKey: "awaiting_your_action",
        title: "Requires your action",
        table: tables.supervisor,
      },
      {
        id: 2,
        apiKey: "awaiting_others_action",
        title: "Awaiting other's action",
        table: tables.supervisor,
      },
      {
        id: 3,
        apiKey: "historical",
        title: "Archives",
        table: tables.supervisor,
      },
    ],
  },
  // ? Disabled according to TEA2-1213
  // ? Might be required in future implementations
  /* {
    id: 3,
    key: "additional-acceptor",
    label: "Additional Acceptor",
    accordions: [
      {
        id: 1,
        apiKey: "awaiting_your_action",
        title: "Requires your action",
        table: tables["additional-acceptor"],
      },
      {
        id: 2,
        apiKey: "awaiting_others_action",
        title: "Awaiting other's action",
        table: tables["additional-acceptor"],
      },
      {
        id: 3,
        apiKey: "historical",
        title: "Archives",
        table: tables["additional-acceptor"],
      },
    ],
  }, */
];
